import { useFormQuestionStore } from "../stores/form-question-store";

export function useFormQuestions() {
	const questions = useFormQuestionStore((store) => store.questions);
	const indexQuestions = useFormQuestionStore((store) => store.index);
	const showQuestion = useFormQuestionStore((store) => store.show);
	const createQuestion = useFormQuestionStore((store) => store.create);
	const updateQuestion = useFormQuestionStore((store) => store.update);
	const deleteQuestion = useFormQuestionStore((store) => store.delete);
	const restoreQuestion = useFormQuestionStore((store) => store.restore);
	const forceDeleteQuestion = useFormQuestionStore((store) => store.forceDelete);

	return {
		questions,
		indexQuestions,
		showQuestion,
		createQuestion,
		updateQuestion,
		deleteQuestion,
		restoreQuestion,
		forceDeleteQuestion,
	};
}
